'use client';

import { createContext } from 'react';

import type { FieldSetContextInterface } from '../types/field-set.types';

export const FieldSetContext = createContext<FieldSetContextInterface>({});

FieldSetContext.displayName = 'FieldSet.Context';
